const state = {
  pushExist: '',
  pushCounted: ''
}

const getters = {
  getPushExist: state => state.pushExist,
  getPushCounted: state => state.pushCounted
}

const mutations = {
  SET_PUSHEXIST (state, payload) {
    state.pushExist = payload
  },
  SET_PUSHCOUNTED (state, payload) {
    state.pushCounted = payload
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters
}
